var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Click-to-Pay-Styles-for-UI-Display",
    transform: "translate(-3824.000000, -619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_dark_v3.1_178x32",
    transform: "translate(3776.000000, 612.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v4_mark_light_S_15px",
    transform: "translate(14.500000, 7.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MC",
    transform: "translate(34.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mc_symbol"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5F00",
    x: 9.54692308,
    y: 1.89561644,
    width: 7.99846152,
    height: 13.1831507
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3707692,8.48835615 C10.3687609,5.9162332 11.5388328,3.4860197 13.5438461,1.8979452 C10.1376439,-0.803412601 5.24620091,-0.409936474 2.30709182,2.80184914 C-0.632017274,6.01363474 -0.632017274,10.9654063 2.30709182,14.1771919 C5.24620091,17.3889776 10.1376439,17.7824537 13.5438461,15.0810959 C11.5381947,13.4925171 10.3680514,11.0612963 10.3707692,8.48835615 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F79E1B",
    points: "26.037982 13.7760322 26.037982 13.4940046 26.1523888 13.4940046 26.1523888 13.447 25.8778125 13.447 25.8778125 13.4940046 25.9922193 13.4940046 25.9922193 13.7760322"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F79E1B",
    points: "26.5645392 13.447 26.4730138 13.447 26.3814883 13.682023 26.2899629 13.447 26.1984375 13.447 26.1984375 13.7760322 26.2670816 13.7760322 26.2670816 13.5175069 26.3431635 13.7290277 26.4272511 13.7290277 26.5008388 13.5175069 26.5008388 13.7760322 26.5645392 13.7760322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9861539,8.48835615 C26.9861539,11.6981845 25.1698664,14.6262062 22.3088666,16.0288794 C19.4478669,17.4315526 16.0443669,17.0626193 13.5438461,15.0787671 C15.5479847,13.4893444 16.7181446,11.059454 16.7181446,8.48719178 C16.7181446,5.9149296 15.5479847,3.48503916 13.5438461,1.89561644 C16.0443669,-0.0882357813 19.4478669,-0.45716899 22.3088666,0.945504164 C25.1698664,2.34817732 26.9861539,5.27619909 26.9861539,8.4860274 L26.9861539,8.48835615 Z",
    id: "Path",
    fill: "#F79E1B"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-export",
    x: 0,
    y: 0,
    width: 27,
    height: 18
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/mc.2fba5490e9c305c2b4dea1c45deaa588.svg";
export { ForwardRef as ReactComponent };